// src/components/SupplierDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Grid
} from '@mui/material';

function SupplierDialog({ open, onClose, onSave, initialSupplier }) {
  const [supplier, setSupplier] = useState({
    code: '', name: '', representative: '', phone: '', address: ''
  });

  useEffect(() => {
    if (open) {
      if (initialSupplier) {
        setSupplier(initialSupplier);
      } else {
        setSupplier({ code: '', name: '', representative: '', phone: '', address: '' });
      }
    }
  }, [open, initialSupplier]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSupplier(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (!supplier.code || !supplier.name) {
      alert('Vui lòng nhập Mã và Tên nhà cung cấp.');
      return;
    }
    onSave(supplier);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialSupplier ? 'Sửa Nhà Cung Cấp' : 'Tạo Nhà Cung Cấp Mới'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              autoFocus
              name="code"
              label="Mã NCC / Mã số thuế"
              fullWidth
              value={supplier.code}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              name="name"
              label="Tên nhà cung cấp"
              fullWidth
              value={supplier.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="representative"
              label="Người đại diện"
              fullWidth
              value={supplier.representative}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="phone"
              label="Số điện thoại"
              fullWidth
              value={supplier.phone}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="address"
              label="Địa chỉ"
              fullWidth
              value={supplier.address}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Hủy</Button>
        <Button onClick={handleSave} variant="contained">Lưu</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SupplierDialog;